// ─── Manual Bank Transfer ───────────────────────────────────────────────────
// Depends on: main.js globals → purchaseCheck, inventoryCheck, getCardInfo,
// getUserInfo, getCookie, showToast, popupOpen, popupClose, trackCheckOut,
// trackPurchaseFail, saveIsReceivingContract, prepareCheckoutError, getSection
// window globals → GMO_APP_URL, sz_config, meta.page.customerId, customerEmail,
// CHECKOUT_ERROR_MESSAGES, purchase_message

var _manualBankState = {
  orderId: null,
  orderNumber: null,
  orderToken: null,
  /** Payer name (振込依頼人名) once saved at Step 2; null until registered. */
  payerName: null,
  isEditingPayerName: false,
  orderAmount: 0,
  orderTax: 0,
  orderTotal: 0,
  availableBalance: 0,
  balanceUsed: 0,
  transferAmount: 0,
  useBalance: false,
  orderCurrency: 'JPY',
  selectedBankCode: '',
  apiUrl: null,
  /** When true: step1 confirm → open contract popup; order is created after confirm-contract with saleContract. */
  awaitingContractAfterStep1: false,
  /** Cart / drawer button used for `.customer-no-card` and disabled state; set in openManualBankStep1. */
  triggerBtn: null
};

function deriveManualBankSummary(data) {
  var tax = parseFloat(data && data.tax) || 0;
  var total = parseFloat(data && data.total) || 0;
  var balanceUsed = parseFloat(data && data.balanceUsed) || 0;
  var transferAmount = data && data.transferAmount != null
    ? parseFloat(data.transferAmount)
    : total;
  if (isNaN(transferAmount)) transferAmount = total;

  return {
    orderAmount: Math.max(0, total - tax),
    orderTax: tax,
    totalPayment: transferAmount,
    balanceUsed: balanceUsed,
    fullCover: balanceUsed > 0 && transferAmount === 0
  };
}
// ─── end manual-bank balance pure helpers ───

function formatManualBankMoney(amount) {
  return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(parseFloat(amount) || 0);
}

function buildManualBankOrderUrl(orderToken) {
  if (!orderToken) return '';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  return root + 'account/orders/' + encodeURIComponent(orderToken);
}

/** Resolves to the customer's available balance (0 on no login, API error, or fetch failure). */
function fetchManualBankBalance(customerId) {
  if (!customerId) return Promise.resolve(0);

  var apiBase = _manualBankState.apiUrl || window.GMO_APP_URL;
  return fetch(apiBase + 'api/bank-transfer/customer/balance?customerId=' + encodeURIComponent(customerId), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': Shopify.locale,
      'X-Sig': window.sz_config.gmo_key,
      'X-Epoch': window.sz_config.timestamp,
      "ngrok-skip-browser-warning": "true"
    }
  })
  .then(function(r) { return r.json(); })
  .then(function(response) {
    return response && !response.errors
      ? (parseFloat(response.availableBalance) || 0)
      : 0;
  })
  .catch(function(err) {
    console.error('fetchManualBankBalance error', err);
    return 0;
  });
}

/**
 * Balance confirmation step inside #popup-manual-bank, shown only when
 * availableBalance > 0 before the order is created.
 */
function openManualBankBalanceStep(customerId, btn) {
  var step = document.getElementById('manualBankBalanceStep');
  if (!step) {
    openManualBankStep1(customerId, btn);
    return;
  }

  var step2 = document.getElementById('manualBankStep2');
  var amount = document.getElementById('manual-bank-balance-step-amount');
  var checkbox = document.getElementById('manual-bank-use-balance');
  var continueBtn = document.getElementById('manual-bank-balance-continue-btn');
  var closeBtn = document.getElementById('manual-bank-balance-close-btn');

  if (amount) amount.textContent = formatManualBankMoney(_manualBankState.availableBalance) + ' JPY';
  if (checkbox) checkbox.checked = true;
  if (step2) step2.style.display = 'none';
  step.style.display = '';

  function closeBalancePopup() {
    step.style.display = 'none';
    if (typeof popupClose === 'function') popupClose('popup-manual-bank');
    else document.getElementById('popup-manual-bank').style.display = 'none';
  }

  if (continueBtn) {
    continueBtn.onclick = function() {
      _manualBankState.useBalance = !!(checkbox && checkbox.checked);
      closeBalancePopup();
      openManualBankStep1(customerId, btn);
    };
  }
  if (closeBtn) {
    closeBtn.onclick = function() {
      closeBalancePopup();
      if (btn && btn.removeAttribute) btn.removeAttribute('disabled');
    };
  }

  if (typeof popupOpen === 'function') popupOpen('popup-manual-bank');
  else document.getElementById('popup-manual-bank').style.display = 'block';
}

/** Clears loading/disabled on step-1 CTAs (set on click; must reset on success, error, or reopen). */
function resetManualBankStep1Buttons() {
  var ns = document.getElementById('manual-bank-name-submit-btn');
  var sc = document.getElementById('manual-bank-step1-confirm-btn');
  if (ns) {
    ns.classList.remove('is-loading');
    ns.disabled = false;
  }
  if (sc) {
    sc.classList.remove('is-loading');
    sc.disabled = false;
  }
}

function openManualBankStep1(customerId, btn) {
  _manualBankState.triggerBtn = btn;

  if (_manualBankState.awaitingContractAfterStep1) {
    proceedManualBankToContract(customerId);
  } else {
    submitStep1(customerId);
  }
}

/** Skip bank-name save; go directly to contract popup (is_receiving_contract flow). */
function proceedManualBankToContract(customerId) {
  var contractInfoElement = document.querySelector('contract-information');
  if (contractInfoElement && typeof contractInfoElement.getSaleInfo === 'function') {
    var loading_bg = document.querySelector('.loading_bg');
    if (loading_bg) loading_bg.style.display = 'block';
    contractInfoElement
      .getSaleInfo(customerId)
      .then(function(result) {
        if (loading_bg) loading_bg.style.display = 'none';
        if (result.success && result.exists && result.data) {
          if (typeof contractInfoElement.populateFormFromSaleInfo === 'function') {
            contractInfoElement.populateFormFromSaleInfo(result.data);
          }
        }
        if (typeof contractInfoElement.initializePaymentHandler === 'function') {
          contractInfoElement.initializePaymentHandler('manual-bank');
        }
        if (typeof popupOpen === 'function') popupOpen('popup_contract_information');
      })
      .catch(function() {
        if (loading_bg) loading_bg.style.display = 'none';
        if (typeof contractInfoElement.initializePaymentHandler === 'function') {
          contractInfoElement.initializePaymentHandler('manual-bank');
        }
        if (typeof popupOpen === 'function') popupOpen('popup_contract_information');
      });
  } else {
    if (typeof popupOpen === 'function') popupOpen('popup_contract_information');
  }
}

function submitStep1(customerId, saleContract) {
  var loading_bg  = document.querySelector('.loading_bg');
  var apiBase     = _manualBankState.apiUrl || window.GMO_APP_URL;
  var email       = window.customerEmail || '';

  if (loading_bg) loading_bg.style.display = 'block';

  getSection('cart-data').then(function(data) {
    var cartData = JSON.parse(data);
    var items = cartData.items || [];

    var requestBody = {
      customer_id: customerId,
      email: email,
      items: items
    };

    var affid = getCookie('affid');
    var oid   = getCookie('oid');
    if (affid && oid) requestBody.affInfo = { affId: affid, oid: oid };
    if (saleContract) {
      requestBody.saleContract = saleContract;
    }
    if (_manualBankState.useBalance) {
      requestBody.useBalance = true;
    }

    var itemsForTracking = items.map(function(item) {
      return {
        item_id: item.id,
        item_name: item.title,
        avatar_id: item.id,
        avatar_sku: item.sku,
        item_brand: item.avatar_type || '',
        price: item.price / 100,
        quantity: item.quantity
      };
    });
    trackCheckOut('MANUAL_BANK', {}, itemsForTracking);

    return Promise.all([
      fetch(apiBase + 'api/bank-transfer/order/create', {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': Shopify.locale,
          'X-Sig': window.sz_config.gmo_key,
          'X-Epoch': window.sz_config.timestamp
        }
      }).then(function(r) { return r.json(); }),

      fetch(apiBase + 'api/merchant-banks?customer_id=' + customerId, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': Shopify.locale,
          'X-Sig': window.sz_config.gmo_key,
          'X-Epoch': window.sz_config.timestamp,
          "ngrok-skip-browser-warning": "true"
        }
      }).then(function(r) { return r.json(); })
      .catch(function(err) {
          console.error('fetch merchant banks error', err);
          return { banks: [] };
        })
    ]);
  })
  .then(function(results) {
    if (loading_bg) loading_bg.style.display = 'none';
    var orderResponse = results[0];
    var banksResponse = results[1];

    if (orderResponse.errors) {
      var errorMessage = Object.values(orderResponse.errors)[0];
      errorMessage = prepareCheckoutError(orderResponse, errorMessage, window.CHECKOUT_ERROR_MESSAGES.OUTSTOCK);
      var errorMsg  = document.getElementById('manual-bank-error-msg');
      var btnView   = document.getElementById('manual-bank-error-btn-view');
      if (errorMsg) errorMsg.textContent = errorMessage;
      if (btnView) btnView.style.display = orderResponse.errors.hasPendingOrder ? '' : 'none';
      if (typeof popupClose === 'function') popupClose('popup-manual-bank');
      else document.getElementById('popup-manual-bank').style.display = 'none';
      if (typeof popupOpen === 'function') popupOpen('popup-manual-bank-error');
      else document.getElementById('popup-manual-bank-error').style.display = 'block';
      if (typeof trackPurchaseFail === 'function') trackPurchaseFail(errorMessage);
      resetManualBankStep1Buttons();
      return;
    }

    // Success — save state.
    // Supports bank-transfer API shape: { orderId, total, tax, currency, ... }
    // and legacy Shopify-style: { id, total_price, subtotal_price, total_tax, currency }.
    var order = orderResponse.order || orderResponse;
    _manualBankState.orderId =
      order.orderId != null ? order.orderId : (order.id != null ? order.id : order.order_id);
    _manualBankState.orderNumber =
      order.orderNumber != null ? order.orderNumber : (order.order_number != null ? order.order_number : order.name);
    _manualBankState.orderToken =
      order.orderToken != null ? order.orderToken : (order.order_token != null ? order.order_token : order.token);
    // New order → payer name not yet entered.
    _manualBankState.payerName = null;
    _manualBankState.isEditingPayerName = false;

    _manualBankState.orderCurrency = order.currency || 'JPY';

    var tax = parseFloat(
      order.tax != null ? order.tax : (order.total_tax != null ? order.total_tax : 0)
    ) || 0;
    var total = parseFloat(
      order.total != null ? order.total : (order.total_price != null ? order.total_price : 0)
    ) || 0;
    var subtotal = parseFloat(
      order.subtotal != null ? order.subtotal : (order.subtotal_price != null ? order.subtotal_price : NaN)
    );
    if (isNaN(subtotal)) {
      subtotal = Math.max(0, total - tax);
    }

    _manualBankState.orderAmount = subtotal;
    _manualBankState.orderTax = tax;
    _manualBankState.orderTotal = total > 0 ? total : subtotal + tax;
    _manualBankState.balanceUsed = parseFloat(order.balanceUsed) || 0;
    _manualBankState.transferAmount = order.transferAmount != null
      ? (parseFloat(order.transferAmount) || 0)
      : _manualBankState.orderTotal;

    var banks = Array.isArray(banksResponse) ? banksResponse : (banksResponse.banks || []);

    var fullCover = _manualBankState.balanceUsed > 0 && _manualBankState.transferAmount === 0;
    if (!fullCover && !banks.length) {
      showToast('No bank accounts available. Please contact support.', 'error', 6000);
      return;
    }

    // Open popup now that step2 content is ready (works for both contract and non-contract flows)
    if (typeof popupOpen === 'function') popupOpen('popup-manual-bank');
    else { var mp = document.getElementById('popup-manual-bank'); if (mp) mp.style.display = 'block'; }

    renderManualBankStep2(banks, _manualBankState.orderId);
  })
  .catch(function(err) {
    console.error('submitStep1 error', err);
    if (loading_bg) loading_bg.style.display = 'none';
    resetManualBankStep1Buttons();
    showToast('An error occurred. Please try again.', 'error', 4000);
  });
}

function renderManualBankStep2(banks, orderId) {
  var balanceStep = document.getElementById('manualBankBalanceStep');
  if (balanceStep) balanceStep.style.display = 'none';
  var step2 = document.getElementById('manualBankStep2');
  var subtitle = document.getElementById('manual-bank-step2-subtitle');
  var summaryAmount = document.getElementById('manual-bank-summary-amount');
  var summaryTax    = document.getElementById('manual-bank-summary-tax');
  var summaryTotal  = document.getElementById('manual-bank-summary-total');
  var summaryBalanceUsed = document.getElementById('manual-bank-summary-balance-used');
  var summaryBalanceUsedRow = document.getElementById('manual-bank-summary-balance-used-row');
  var fullCoverBlock = document.getElementById('manual-bank-full-cover');
  var fullCoverOrderId = document.getElementById('manual-bank-full-cover-order-id');
  var fullCoverOrderNumber = document.getElementById('manual-bank-full-cover-order-number');
  var fullCoverOrderLink = document.getElementById('manual-bank-full-cover-order-link');
  var bankFlow = document.getElementById('manual-bank-bank-flow');
  var confirmBtn = document.getElementById('manual-bank-confirm-btn');
  var cancelBtn  = document.getElementById('manual-bank-cancel-btn');
  var fullCoverCloseBtn = document.getElementById('manual-bank-full-cover-close-btn');
  var loading_bg = document.querySelector('.loading_bg');

  var currency = _manualBankState.orderCurrency;
  var fmt = formatManualBankMoney;
  var summary = deriveManualBankSummary({
    total: _manualBankState.orderTotal,
    tax: _manualBankState.orderTax,
    balanceUsed: _manualBankState.balanceUsed,
    transferAmount: _manualBankState.transferAmount
  });

  if (subtitle) {
    var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
    var tpl = i18n.step2_subtitle_with_amount || 'Please transfer [amount] to one of the accounts below.';
    subtitle.textContent = summary.fullCover
      ? (i18n.no_transfer_required || 'No bank transfer is required for this order.')
      : tpl.replace('[amount]', fmt(summary.totalPayment));
  }
if (summaryAmount) summaryAmount.textContent = fmt(summary.orderAmount) + ' ' + currency;
  if (summaryTax)    summaryTax.textContent    = fmt(summary.orderTax)    + ' ' + currency;
  if (summaryTotal)  summaryTotal.textContent  = fmt(summary.totalPayment)  + ' ' + currency;
  if (summaryBalanceUsedRow) summaryBalanceUsedRow.style.display = summary.balanceUsed > 0 ? '' : 'none';
  if (summaryBalanceUsed) summaryBalanceUsed.textContent = fmt(summary.balanceUsed) + ' ' + currency;
  if (fullCoverBlock) fullCoverBlock.style.display = summary.fullCover ? '' : 'none';
  if (fullCoverOrderId) fullCoverOrderId.textContent = orderId || '';
  if (fullCoverOrderNumber) fullCoverOrderNumber.textContent = _manualBankState.orderNumber || '';
  if (fullCoverOrderLink) {
    var orderUrl = buildManualBankOrderUrl(_manualBankState.orderToken);
    if (orderUrl && _manualBankState.orderNumber) {
      fullCoverOrderLink.href = orderUrl;
      fullCoverOrderLink.textContent = _manualBankState.orderNumber;
      fullCoverOrderLink.style.display = '';
      if (fullCoverOrderNumber) fullCoverOrderNumber.style.display = 'none';
    } else {
      fullCoverOrderLink.style.display = 'none';
      if (fullCoverOrderNumber) fullCoverOrderNumber.style.display = '';
    }
  }
  if (bankFlow) bankFlow.style.display = summary.fullCover ? 'none' : '';

  _manualBankState.selectedBankCode = '';
  if (confirmBtn) confirmBtn.disabled = true;

  if (!summary.fullCover) {
    renderBankList(banks, orderId);
  }

  step2.style.display = '';

  // ── Cancel Order (actual API call) ──────────────────────────────────────
  function executeCancelOrder() {
    var customerId = window.meta && window.meta.page && window.meta.page.customerId;
    if (loading_bg) loading_bg.style.display = 'block';
    var apiBase = _manualBankState.apiUrl || window.GMO_APP_URL;
    fetch(apiBase + 'api/order/cancel', {
      method: 'POST',
      body: JSON.stringify({ customerId: customerId, spOrderId: _manualBankState.orderId }),
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': Shopify.locale,
        'X-Sig': window.sz_config.gmo_key,
        'X-Epoch': window.sz_config.timestamp
      }
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (loading_bg) loading_bg.style.display = 'none';
      if (typeof popupClose === 'function') popupClose('popup-manual-bank');
      else document.getElementById('popup-manual-bank').style.display = 'none';
      clearManualBankCart();
    })
    .catch(function(err) {
      console.error('cancel order error', err);
      if (loading_bg) loading_bg.style.display = 'none';
      if (typeof popupClose === 'function') popupClose('popup-manual-bank');
      else document.getElementById('popup-manual-bank').style.display = 'none';
      clearManualBankCart();
    });
  }

  // ── Show cancel confirmation dialog ───────────────────────────────────
  var cancelConfirmOverlay = document.getElementById('manual-bank-cancel-confirm');
  var cancelConfirmYes = document.getElementById('manual-bank-cancel-confirm-yes');
  var cancelConfirmNo  = document.getElementById('manual-bank-cancel-confirm-no');

  function showCancelConfirm() {
    if (cancelConfirmOverlay) cancelConfirmOverlay.classList.add('is-visible');
  }
  function hideCancelConfirm() {
    if (cancelConfirmOverlay) cancelConfirmOverlay.classList.remove('is-visible');
  }

  if (cancelConfirmYes) {
    cancelConfirmYes.onclick = function() {
      hideCancelConfirm();
      executeCancelOrder();
    };
  }
  if (cancelConfirmNo) {
    cancelConfirmNo.onclick = function() {
      hideCancelConfirm();
    };
  }

  // ── Cancel Order button → show confirmation ───────────────────────────
  if (cancelBtn) {
    cancelBtn.onclick = function() {
      showCancelConfirm();
    };
  }
  if (fullCoverCloseBtn) {
    fullCoverCloseBtn.onclick = function() {
      if (typeof popupClose === 'function') popupClose('popup-manual-bank');
      else document.getElementById('popup-manual-bank').style.display = 'none';
      clearManualBankCart();
    };
  }

  // ── X close button in Step 2 → show confirmation ──────────────────────
  document.getElementById('manual-bank-close-btn').onclick = function(e) {
    if (e) e.preventDefault();
    showCancelConfirm();
  };

  // ── I've completed the transfer ───────────────────────────────────────
    if (confirmBtn) {
    confirmBtn.onclick = function() {
      if (typeof popupClose === 'function') popupClose('popup-manual-bank');
      else document.getElementById('popup-manual-bank').style.display = 'none';
      clearManualBankCart();
      var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
      showToast(
        i18n.toast_transfer_confirmed || "Thank you! Please allow up to 24 hours for us to confirm your payment and process your order.",
        'success',
        6000
      );
    };
  }
}

// ─── payer-name pure helpers ────────────────────────────────────────────────
// Katakana validator — mirrors the server-side rule (app/utils/payerName.js).
function isValidPayerName(s) {
  if (typeof s !== 'string') return false;
  var v = s.trim();
  return v.length > 0 && v.length <= 50 && /^[ァ-ヶーｦ-ﾟ　\s]+$/.test(v);
}

// String the customer copies into the bank "transferor name" field: name + order id.
function buildTransferorString(payerName, orderNumber) {
  return String(payerName == null ? '' : payerName).trim()
    + String(orderNumber == null ? '' : orderNumber).replace(/^#/, '');
}
// ─── end payer-name pure helpers ───

// POST the payer name to the service. Calls onSuccess() / onError(message).
function savePayerName(payerName, onSuccess, onError) {
  var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
  var apiBase = _manualBankState.apiUrl || window.GMO_APP_URL;
  var customerId = window.meta && window.meta.page && window.meta.page.customerId;
  var email = window.customerEmail;
  console.log('[manual-bank][payer-name] saving payerName for orderId=' + _manualBankState.orderId);
  fetch(apiBase + 'api/bank-transfer/order/update-payer-name', {
    method: 'POST',
    body: JSON.stringify({
      customerId: customerId,
      email: email,
      orderId: _manualBankState.orderId,
      payerName: payerName
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': Shopify.locale,
      'X-Sig': window.sz_config.gmo_key,
      'X-Epoch': window.sz_config.timestamp
    }
  })
  .then(function(r) { return r.json(); })
  .then(function(res) {
    if (res && res.errors === false) {
      console.log('[manual-bank][payer-name] save success for orderId=' + _manualBankState.orderId);
      onSuccess();
    } else {
      console.error('[manual-bank][payer-name] save rejected', res && res.errors);
      onError(i18n.payer_name_save_failed || 'Failed to save. Please try again.');
    }
  })
  .catch(function(err) {
    console.error('[manual-bank][payer-name] save error', err);
    onError(i18n.payer_name_save_failed || 'Failed to save. Please try again.');
  });
}

// Update the payer-name UI in place (payer section, transferor row, copy locks) WITHOUT
// rebuilding the bank list — preserves the selected bank checkbox and open accordion state.
function refreshPayerNameUI() {
  var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
  var copyLabel = i18n.copy || 'Copy';
  var registered = _payerNameIsRegistered();
  document.querySelectorAll('.manual-bank__section--manual').forEach(function(section) {
    var payer = section.querySelector('.manual-bank__payer-section--manual');
    if (payer) payer.replaceWith(createPayerInputSection());
    var transferor = section.querySelector('.bank-field--highlight--manual');
    if (transferor) transferor.replaceWith(createTransferorValueRow(_manualBankState.orderId, copyLabel));
    section.querySelectorAll('.bank-field__copy--other').forEach(function(btn) {
      btn.disabled = !registered;
      btn.classList.remove('copied');
    });
  });
}

var _payerNameIsRegistered = function() {
  return !!_manualBankState.payerName && !_manualBankState.isEditingPayerName;
};

// Dedicated "振込依頼人名の入力" section shown at the top of each bank body.
// Always visible. Unsaved/editing → input + Register; saved → filled input + edit link.
function createPayerInputSection() {
  var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};

  var section = document.createElement('div');
  section.className = 'manual-bank__payer-section--manual';

  var title = document.createElement('div');
  title.className = 'manual-bank__payer-title--manual';
  var titleText = document.createElement('span');
  titleText.textContent = i18n.payer_name_label || 'Payer name';
  var required = document.createElement('span');
  required.className = 'manual-bank__payer-required--manual';
  required.textContent = i18n.payer_name_required_badge || 'Required';
  title.appendChild(titleText);
  title.appendChild(required);
  section.appendChild(title);

  var line = document.createElement('div');
  line.className = 'manual-bank__input-line--manual';

  var input = document.createElement('input');
  input.type = 'text';
  input.className = 'manual-name-input--manual';
  input.placeholder = i18n.payer_name_placeholder || '';
  input.value = _manualBankState.payerName || '';

  var hint = document.createElement('div');
  hint.className = 'manual-name-hint--manual';
  hint.textContent = i18n.payer_name_hint || '';

  var registered = _payerNameIsRegistered();

  var actionBtn = document.createElement('button');
  actionBtn.type = 'button';

  if (registered) {
    // Filled + locked input, green "✓ 登録済み" button, edit link below.
    input.disabled = true;
    actionBtn.className = 'bank-modal__primary-btn--manual is-inline is-registered';
    actionBtn.disabled = true;
    actionBtn.textContent = '✓ ' + (i18n.payer_name_registered || 'Registered');

    line.appendChild(input);
    line.appendChild(actionBtn);
    section.appendChild(line);
    section.appendChild(hint);

    var editLink = document.createElement('button');
    editLink.type = 'button';
    editLink.className = 'manual-bank__edit-link--manual';
    editLink.textContent = i18n.payer_name_edit || 'Edit';
    editLink.addEventListener('click', function() {
      _manualBankState.isEditingPayerName = true;
      refreshPayerNameUI();
    });
    section.appendChild(editLink);
    return section;
  }

  // Clear the error state as soon as the user edits the field again.
  input.addEventListener('input', function() {
    if (input.classList.contains('is-error')) {
      input.classList.remove('is-error');
      input.removeAttribute('title');
      hint.classList.remove('is-error');
      hint.textContent = i18n.payer_name_hint || '';
    }
  });

  // Unsaved / editing → Register button posts to the service.
  actionBtn.className = 'bank-modal__primary-btn--manual is-inline';
  actionBtn.textContent = i18n.payer_name_register || 'Register';
  actionBtn.addEventListener('click', function() {
    var value = input.value.trim();
    if (!isValidPayerName(value)) {
      var invalidMsg = i18n.payer_name_invalid || 'Please enter katakana only.';
      hint.textContent = invalidMsg;
      hint.classList.add('is-error');
      input.classList.add('is-error');
      input.setAttribute('title', invalidMsg); // tooltip on hover
      input.focus();
      return;
    }
    actionBtn.disabled = true;
    savePayerName(value, function() {
      _manualBankState.payerName = value;
      _manualBankState.isEditingPayerName = false;
      refreshPayerNameUI();
    }, function(message) {
      actionBtn.disabled = false;
      if (typeof showToast === 'function') showToast(message, 'error', 4000);
    });
  });

  line.appendChild(input);
  line.appendChild(actionBtn);
  section.appendChild(line);
  section.appendChild(hint);
  return section;
}

// Highlighted "振込依頼人名 (必須)" detail row: the string the customer copies into the
// bank transferor field = payerName + internal orderId (per AIAOP-45 decision).
// Empty + copy-disabled until the payer name is registered.
function createTransferorValueRow(orderId, copyLabel) {
  var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
  var registered = _payerNameIsRegistered();

  var row = document.createElement('div');
  row.className = 'bank-field--manual bank-field--highlight--manual';

  var labelSpan = document.createElement('span');
  labelSpan.className = 'bank-field__label--manual';
  labelSpan.textContent = (i18n.payer_name_label || 'Payer name')
    + ' (' + (i18n.payer_name_required_badge || 'Required') + ')';

  var displayValue = registered ? buildTransferorString(_manualBankState.payerName, orderId) : '';
  var valueSpan = document.createElement('span');
  valueSpan.className = 'bank-field__value--manual';
  valueSpan.textContent = displayValue;

  var copyBtn = document.createElement('button');
  copyBtn.className = 'bank-field__copy--manual bank-field__copy--remarks';
  copyBtn.textContent = copyLabel;
  copyBtn.disabled = !registered;
  copyBtn.addEventListener('click', function() {
    copyManualBankRemarks(copyBtn, displayValue);
  });

  row.appendChild(labelSpan);
  row.appendChild(valueSpan);
  row.appendChild(copyBtn);
  return row;
}

function renderBankList(banks, orderId) {
  var container = document.getElementById('manual-bank-list');
  if (!container) return;

  var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
  var copyLabel = i18n.copy || 'Copy';

  container.textContent = '';

  banks.forEach(function(bank) {
    var bankId   = 'manualBank_' + bank.id;
    var chkId    = 'manualBankChk_' + bank.id;
    var bankCode = bank.bankCode || '';

    function createFieldRow(label, value, extraClass) {
      extraClass = extraClass || '';
      var val = String(value || '');
      var rowKey = label.replace(/\s/g, '');

      var row = document.createElement('div');
      row.className = 'bank-field--manual' + (extraClass ? ' ' + extraClass : '');

      var labelSpan = document.createElement('span');
      labelSpan.className = 'bank-field__label--manual';
      labelSpan.textContent = label;

      var valueSpan = document.createElement('span');
      valueSpan.className = 'bank-field__value--manual bank-field-val_' + bankId + '_' + rowKey;
      valueSpan.textContent = val;

      var copyBtn = document.createElement('button');
      copyBtn.className = 'bank-field__copy--manual bank-field__copy--other';
      copyBtn.textContent = copyLabel;
      // Bank details stay locked until the payer name is registered.
      if (!_payerNameIsRegistered()) copyBtn.disabled = true;
      copyBtn.addEventListener('click', function() {
        copyManualBankField(copyBtn, val);
      });

      row.appendChild(labelSpan);
      row.appendChild(valueSpan);
      row.appendChild(copyBtn);
      return row;
    }

    var payerSection = createPayerInputSection();
    var transferorRow = createTransferorValueRow(orderId, copyLabel);

    var section = document.createElement('div');
    section.className = 'manual-bank__section--manual';
    section.id = bankId;
    section.setAttribute('data-bank-code', bankCode);

    var option = document.createElement('div');
    option.className = 'manual-bank__option--manual';

    var labelEl = document.createElement('label');
    labelEl.className = 'manual-bank__label--manual';
    labelEl.setAttribute('for', chkId);

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'manual-bank__checkbox--manual';
    checkbox.id = chkId;
    checkbox.addEventListener('change', function() {
      onManualBankToggle(bankCode, checkbox.checked);
    });

    var nameSpan = document.createElement('span');
    nameSpan.className = 'manual-bank__name--manual';
    nameSpan.textContent = bank.bankNameEn || bank.bankName || '';

    labelEl.appendChild(checkbox);
    labelEl.appendChild(nameSpan);

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'manual-bank__chevron--manual');
    svg.setAttribute('viewBox', '0 0 24 24');
    var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    polyline.setAttribute('points', '6 9 12 15 18 9');
    svg.appendChild(polyline);

    option.appendChild(labelEl);
    option.appendChild(svg);

    var body = document.createElement('div');
    body.className = 'manual-bank__body--manual';

    var innerDiv = document.createElement('div');
    innerDiv.style.paddingTop = '8px';

    innerDiv.appendChild(payerSection);
    innerDiv.appendChild(transferorRow);
    innerDiv.appendChild(createFieldRow(i18n.bank_code || 'Bank code',        bank.bankCode));
    innerDiv.appendChild(createFieldRow(i18n.bank_name || 'Bank name',        bank.bankName));
    innerDiv.appendChild(createFieldRow(i18n.branch_code || 'Branch code',    bank.branchCode));
    innerDiv.appendChild(createFieldRow(i18n.account_type || 'Account type',  bank.accountType));
    innerDiv.appendChild(createFieldRow(i18n.account_number || 'Account number', bank.accountNumber));
    innerDiv.appendChild(createFieldRow(i18n.holder_name || 'Holder name',    bank.holderName));

    body.appendChild(innerDiv);
    section.appendChild(option);
    section.appendChild(body);
    container.appendChild(section);
  });
}

/**
 * Copy the transferor-name (remarks) value, then unlock the other bank-detail copy buttons.
 * Used by BOTH flows:
 *   - create modal: the button is only enabled after the payer name is registered.
 *   - order-history resume popup: the button is always enabled; copying it unlocks the rest.
 * A disabled button never fires onclick, so no extra state guard is needed here.
 */
function copyManualBankRemarks(btn, text) {
  if (btn && btn.disabled) return;
  if (!text || text === '—') return;
  var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
  var copyLabel = i18n.copy || 'Copy';
  var copiedLabel = i18n.copied || 'Copied!';

  function unlockOtherButtons() {
    // Scope to the popup that owns this button so the two popups don't affect each other.
    var scope = btn.closest('.popup-resume') || document;
    scope.querySelectorAll('.bank-field__copy--other').forEach(function(otherBtn) {
      otherBtn.disabled = false;
    });
  }

  navigator.clipboard.writeText(String(text)).then(function() {
    btn.textContent = copiedLabel;
    btn.classList.add('copied');
    setTimeout(function() {
      btn.textContent = copyLabel;
      btn.classList.remove('copied');
    }, 1500);
    unlockOtherButtons();
  }).catch(function() {
    unlockOtherButtons();
    if (typeof showToast === 'function') {
      showToast(i18n.copy_failed || 'Copy failed. Please copy manually.', 'warning', 3000);
    }
  });
}

function copyManualBankField(btn, text) {
  // A disabled button never fires onclick; this guards programmatic calls only.
  if (btn && btn.disabled) return;

  var i18n = (window.theme && window.theme.strings && window.theme.strings.manualBankTransfer) || {};
  var copyLabel = i18n.copy || 'Copy';
  var copiedLabel = i18n.copied || 'Copied!';
  navigator.clipboard.writeText(String(text)).then(function() {
    btn.textContent = copiedLabel;
    btn.classList.add('copied');
    setTimeout(function() {
      btn.textContent = copyLabel;
      btn.classList.remove('copied');
    }, 1500);
  }).catch(function() {
    if (typeof showToast === 'function') {
      showToast(i18n.copy_failed || 'Copy failed. Please copy manually.', 'warning', 3000);
    }
  });
}

function clearManualBankCart() {
  fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' })
    .then(function(r) { return r.json(); })
    .then(function() {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    });
}

function onManualBankToggle(bankCode, isChecked) {
  var loading_bg = document.querySelector('.loading_bg');
  var apiBase    = _manualBankState.apiUrl || window.GMO_APP_URL;
  var customerId = window.meta && window.meta.page && window.meta.page.customerId;
  var email      = window.customerEmail || '';
  var confirmBtn = document.getElementById('manual-bank-confirm-btn');

  // Single-select: collapse all other sections, uncheck all other checkboxes
  document.querySelectorAll('.manual-bank__section--manual').forEach(function(section) {
    var sectionCode = section.getAttribute('data-bank-code');
    var isTarget = sectionCode === bankCode;
    section.classList.toggle('is-open', isTarget && isChecked);
  });
  document.querySelectorAll('.manual-bank__checkbox--manual').forEach(function(chk) {
    var section = chk.closest('.manual-bank__section--manual');
    if (section && section.getAttribute('data-bank-code') !== bankCode) {
      chk.checked = false;
    }
  });

  // Copy buttons follow the payer-name registration state (locked until registered).
  var payerRegistered = _payerNameIsRegistered();
  document.querySelectorAll('.bank-field__copy--other, .bank-field__copy--remarks').forEach(function(cpBtn) {
    cpBtn.disabled = !payerRegistered;
    cpBtn.classList.remove('copied');
  });

  if (!isChecked) {
    _manualBankState.selectedBankCode = '';
    if (confirmBtn) confirmBtn.disabled = true;
    return; // unchecked → no API call
  }

  _manualBankState.selectedBankCode = bankCode;
  if (confirmBtn) confirmBtn.disabled = false;

  hideUpdateBankError();
  if (loading_bg) loading_bg.style.display = 'block';

  fetch(apiBase + 'api/bank-transfer/order/update-bank', {
    method: 'POST',
    body: JSON.stringify({
      customerId: customerId,
      email: email,
      orderId: _manualBankState.orderId,
      bankCode: bankCode
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': Shopify.locale,
      'X-Sig': window.sz_config.gmo_key,
      'X-Epoch': window.sz_config.timestamp,
      "ngrok-skip-browser-warning": "true"
    }
  })
  .then(function(r) { return r.json(); })
  .then(function(response) {
    if (loading_bg) loading_bg.style.display = 'none';
    if (response.errors) {
      var errorMessage = Object.values(response.errors)[0] || 'Failed to select bank. Please try again.';
      showUpdateBankError(errorMessage);
    } else {
      hideUpdateBankError();
    }
  })
  .catch(function(err) {
    console.error('update-bank error', err);
    if (loading_bg) loading_bg.style.display = 'none';
    showUpdateBankError('Failed to select bank. Please try again.');
  });
}

function showUpdateBankError(msg) {
  var el = document.getElementById('manual-bank-update-error');
  if (!el) return;
  el.textContent = msg;
  el.classList.add('is-visible');
  el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function hideUpdateBankError() {
  var el = document.getElementById('manual-bank-update-error');
  if (el) el.classList.remove('is-visible');
}

/**
 * Same pre-flight as pay-manual-bank-transfer: purchase limit, inventory, active subs,
 * and when the trigger has `.customer-no-card`, card + Credix phone + term checks.
 */
function runManualBankCheckoutGuards(btn, customerId, onSuccess, onFail) {
  var loading_bg = document.querySelector('.loading_bg');
  btn = btn || {};

  function fail() {
    if (typeof onFail === 'function') onFail();
  }

  function releaseTrigger() {
    if (btn.removeAttribute) btn.removeAttribute('disabled');
  }

  purchaseCheck()
    .then(function(purchase) {
      if (loading_bg) loading_bg.style.display = 'none';
      if (purchase && !purchase.success) {
        var errorMessage =
          window.purchase_message && window.purchase_message[purchase.message]
            ? window.purchase_message[purchase.message]
            : purchase.message;
        showToast(errorMessage, 'error', 6000, {
          limit_value_jpy: purchase.limit_value_jpy,
          limit_duration_days: purchase.limit_duration_days
        });
        releaseTrigger();
        fail();
        return;
      }

      return inventoryCheck().then(function(inventory) {
        if (loading_bg) loading_bg.style.display = 'none';
        console.log('[AIAOP-64][manual-bank-transfer] purchaseTierRestriction=', inventory && inventory.purchaseTierRestriction);
        if (inventory && inventory.agePriceRestriction && inventory.agePriceRestriction.blocked) {
          var reason = inventory.agePriceRestriction.reason || 'age_price_restricted';
          var ageRestrictionMessage = (window.purchase_message && window.purchase_message[reason])
            ? window.purchase_message[reason]
            : reason;
          showToast(ageRestrictionMessage, 'error', 6000);
          releaseTrigger();
          fail();
          return;
        }
        if (inventory && inventory.purchaseTierRestriction && inventory.purchaseTierRestriction.blocked) {
          var tierRestriction = inventory.purchaseTierRestriction;
          var tierRestrictionMessage = getPurchaseTierRestrictionMessage(tierRestriction);
          showToast(tierRestrictionMessage, 'error', 6000);
          releaseTrigger();
          fail();
          return;
        }
        if (inventory && inventory.outOfStockItems && inventory.outOfStockItems.length > 0) {
          popupOpen('popup-product-message');
          releaseTrigger();
          fail();
          return;
        }
        if (inventory && inventory.activeSubs && inventory.activeSubs.length > 0) {
          popupOpen('popup-active-subs');
          releaseTrigger();
          fail();
          return;
        }
        if (inventory && inventory.salonBlocked) {
          setupSalonRestrictionPopup(inventory.salonGachiSku, inventory.salonGachiStatus, inventory.salonRestrictedItems);
          popupOpen('popup-salon-restriction');
          releaseTrigger();
          fail();
          return;
        }

        var authToken = getCookie(window.ENV === 'DEV' ? 'auth-token-test' : 'auth-token');
        var isCredixStyle = btn.classList && btn.classList.contains('customer-no-card');

        if (isCredixStyle) {
          return getCardInfo(customerId)
            .then(function(isCard) {
              if (!isCard) {
                popupOpen('popup-common-secure-payment');
                releaseTrigger();
                fail();
                return;
              }
              if (!authToken) {
                releaseTrigger();
                fail();
                return;
              }
              var authJson;
              try {
                authJson = JSON.parse(authToken);
              } catch (e) {
                releaseTrigger();
                fail();
                return;
              }
              if (!authJson.access_token) {
                releaseTrigger();
                fail();
                return;
              }
              return getUserInfo(authJson.access_token)
                .then(function(resData) {
                  if (!resData) {
                    releaseTrigger();
                    fail();
                    return;
                  }
                  if (!resData.verify_phone_status) {
                    popupOpen('popup-common-verified-phone');
                    releaseTrigger();
                    fail();
                    return;
                  }
                  if (!resData.is_agree_credix_term) {
                    popupOpen('popup-common-term-condition');
                    releaseTrigger();
                    fail();
                    return;
                  }
                  onSuccess();
                })
                .catch(function() {
                  releaseTrigger();
                  fail();
                });
            })
            .catch(function() {
              releaseTrigger();
              fail();
            });
        }

        if (!authToken) {
          releaseTrigger();
          fail();
          return;
        }
        var authJsonElse;
        try {
          authJsonElse = JSON.parse(authToken);
        } catch (e) {
          releaseTrigger();
          fail();
          return;
        }
        if (!authJsonElse.access_token) {
          releaseTrigger();
          fail();
          return;
        }
        return getUserInfo(authJsonElse.access_token)
          .then(function(resData) {
            if (resData && resData.verify_phone_status) {
              onSuccess();
            } else {
              popupOpen('popup-common-verified-phone');
              releaseTrigger();
              fail();
            }
          })
          .catch(function() {
            releaseTrigger();
            fail();
          });
      });
    })
    .catch(function(err) {
      console.error('runManualBankCheckoutGuards error', err);
      if (loading_bg) loading_bg.style.display = 'none';
      releaseTrigger();
      fail();
    });
}

function initManualBankTransfer() {
  var btnCart    = document.getElementById('pay-manual-bank-transfer');
  var btnDrawer  = document.getElementById('pay-manual-bank-transfer-drawer');
  var loading_bg = document.querySelector('.loading_bg');

  function handleClick(btn) {
    var apiBase = btn.getAttribute('data-api');
    _manualBankState.apiUrl = apiBase;
    _manualBankState.useBalance = false;

    var customerId = window.meta && window.meta.page && window.meta.page.customerId;

    // ── Contract: step1 manual bank first, then contract, then order with saleContract ──
    var isReceivingContractInput = document.querySelector('#is_receiving_contract');
    var confirmContractBtn = document.querySelector('#confirm-contract-btn');
    if (isReceivingContractInput && confirmContractBtn) {
      if (isReceivingContractInput.checked) {
        saveIsReceivingContract(true);
        confirmContractBtn.setAttribute('data-payment-method', 'manual-bank');
        _manualBankState.awaitingContractAfterStep1 = true;
        var cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && typeof cartDrawer.close === 'function') cartDrawer.close();
      } else {
        confirmContractBtn.removeAttribute('data-payment-method');
        saveIsReceivingContract(false);
        _manualBankState.awaitingContractAfterStep1 = false;
      }
    } else {
      _manualBankState.awaitingContractAfterStep1 = false;
    }

    // ── Login check ──────────────────────────────────────────────────────
    if (!customerId) {
      window.location.href = window.Shopify.routes.root + 'account';
      return;
    }

    btn.setAttribute('disabled', 'true');
    if (loading_bg) loading_bg.style.display = 'block';

    runManualBankCheckoutGuards(btn, customerId, function() {
      fetchManualBankBalance(customerId).then(function(balance) {
        _manualBankState.availableBalance = balance;
        if (loading_bg) loading_bg.style.display = 'none';
        if (balance > 0) {
          openManualBankBalanceStep(customerId, btn);
        } else {
          openManualBankStep1(customerId, btn);
        }
      });
    });
  }

  if (btnCart)   btnCart.onclick   = function() { handleClick(btnCart); };
  if (btnDrawer) btnDrawer.onclick = function() { handleClick(btnDrawer); };

  // ── Error popup button handlers ───────────────────────────────────────
  var errCloseBtn = document.getElementById('manual-bank-error-close-btn');
  var errViewBtn  = document.getElementById('manual-bank-error-btn-view');
  var errPopup    = document.getElementById('popup-manual-bank-error');

  if (errCloseBtn) {
    errCloseBtn.onclick = function() {
      if (typeof popupClose === 'function') popupClose('popup-manual-bank-error');
      else if (errPopup) errPopup.style.display = 'none';
    };
  }
  if (errViewBtn) {
    errViewBtn.onclick = function() {
      window.location.href = window.Shopify.routes.root + 'account?tab=pending#order-history';
    };
  }
}

/** Called from contract-information after saveSaleInfo when contract → bank order flow. */
window.submitManualBankStep1WithContract = function(customerId, saleContract) {
  submitStep1(customerId, saleContract);
};

initManualBankTransfer();

// If user closes popup_contract_information during manual-bank+contract flow,
// reopen manual-bank step 1 so they can continue.
try {
  if (typeof window.popupClose === 'function' && !window.popupClose.__manualBankWrapped) {
    const originalPopupClose = window.popupClose;
    window.popupClose = function (popupId) {
      if (
        popupId === 'popup_contract_information' &&
        _manualBankState &&
        _manualBankState.awaitingContractAfterStep1
      ) {
        // The confirm flow sets __skipManualBankReopen = true before calling popupClose,
        // then proceeds via submitManualBankStep1WithContract(). All other closes
        // (cancel button, X button, overlay click) are treated as "user cancelled"
        // → just reset the flag and do nothing.
        _manualBankState.awaitingContractAfterStep1 = false;

        if (!window.popupClose.__skipManualBankReopen) {
          // User cancelled — re-enable the checkout button but do NOT create the order.
          var btnCart = document.getElementById('pay-manual-bank-transfer');
          var btnDrawer = document.getElementById('pay-manual-bank-transfer-drawer');
          var btn = btnCart || btnDrawer;
          if (btn) btn.removeAttribute('disabled');
        }
      }
      const result = originalPopupClose.apply(this, arguments);
      // Clear skip flag after using it
      if (popupId === 'popup_contract_information' && window.popupClose.__skipManualBankReopen) {
        window.popupClose.__skipManualBankReopen = false;
      }
      // Closing contract popup must not leave #confirm-contract-btn stuck disabled (initManualBank sets it during saveSaleInfo)
      if (popupId === 'popup_contract_information') {
        var ccb = document.querySelector('#confirm-contract-btn');
        if (ccb) ccb.removeAttribute('disabled');
      }
      return result;
    };
    window.popupClose.__manualBankWrapped = true;
  }
} catch (e) {
  // Fail silently
}
